import React, { useEffect, useState } from "react";
import classes from './HeaderLessonViewer.module.css'
import { onKeyDown } from '../../service';
import { useSelector } from "react-redux";
import * as PathRouter from '../../../../models/PathRoute'
import chatIconWhite from '../../assests/LessonViewer/chatIconWhite.png'
import chatIconBlack from '../../assests/LessonViewer/chatIconBlack.png'
import { useNavigate } from "react-router-dom";
import Team from "../../Team/Team";
import DynamicMessage from "../../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../models/DynamicMessageTypeEnum";


const HeaderLessonViewer = ({ backUrl, btnList, data, handleCloseCallBack, setLoader, currentContentIndex, setCurrentContentIndex, setJumpToQuestion, setShowChat, displayIconChatStyle, showClosePopup = true, showChat, showCloseIcon = true }) => {

    const texts = useSelector(state => state.translate.texts);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const navigate = useNavigate()

    const [message, setMessage] = useState(null)


    useEffect(() => {
        if (!data) return;
        setLoader(false);
        if (data.materialContentPath && data.materialContentType && data.materialContentType !== "Pdf") {
            setCurrentContentIndex(0);
        }
        else {
            setCurrentContentIndex(1);
        }
    }, [data?.materialContentPath, data?.materialContentType])



    function handleCloseBtn() {
        setMessage(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            title={texts.exitLesson}
            cancelFunc={() => setMessage(null)}
            confirmText={texts.exit}
            confirmFunc={goBack} />);

    }

    function goBack() {
        if (handleCloseCallBack) {
            handleCloseCallBack();
            return;
        }
        const constructedUrl = backUrl?.replace('studyGroupId', data?.studyGroupId);
        navigate(`${homeUrl}/${constructedUrl}`);
    }

    return (
        <div className={classes.MenuContainer}>
            <div className={classes.AllBtns}>
                {btnList && btnList.map((btn, i) => <h2 key={i} className={`${classes.btn} ${currentContentIndex === i && classes.currentBtn}`} onClick={() => { setCurrentContentIndex(i); setJumpToQuestion(false) }} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setCurrentContentIndex(i))}>
                    <img className={classes.icon} src={currentContentIndex === i ? btn.iconBlack : btn.iconWhite} alt="icon" />
                    {texts[btn.text]}
                </h2>)}
            </div>
            <h2 className={classes.Details}>
                {<div className={classes.ProjectName}>{data && data.name}</div>}
                <div className={classes.Line} />
                {<div className={classes.TeacherName}>{data && data.teacherFullName ? data.teacherFullName : texts.courseStaff}</div>}
            </h2>

            {data?.id && <Team darkMode={true} lessonIdProp={data.id} data={data?.lessonParticipant} />}

            <div className={classes.ChatIconWrapper} style={{ display: displayIconChatStyle, backgroundColor: showChat ? 'white' : 'unset', boxShadow: !showChat && "unset" }} onClick={setShowChat}>
                <img src={showChat ? chatIconBlack : chatIconWhite} />
            </div>

            {showCloseIcon && <div className={classes.GoBackBtn} onClick={() => showClosePopup ? handleCloseBtn() : goBack()} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCloseBtn())}></div>}
            {message}
        </div>
    )
}

export default HeaderLessonViewer;